import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import BasicButton from '../../Components/Button_Basic';
import Dialog from '../../Services/Common/Dialog';
import DatePicker from '../../Components/Datepicker_Basic';
import FormGroup from '../../Components/Form_Group';
import CardH3 from '../../Components/Card_H3';
import InputBasic from '../../Components/Input_Basic';
import GridModal from '../../Components/Modal_Grid';
import EmptyBox from '../../Components/EmptyBox';
import AgDatePicker from '../../Components/agGrid/ag-DatePicker';
import BasicArea from '../../Components/PDA/BarcodeArea';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import BasicCombo from '../../Components/Combo_Basic';
import BasicInput from '../../Components/Input_Basic';
import { Autocomplete, TextField } from '@mui/material';
import Commons from '../../Services/Common/Common';
function ST10060(props) {
    React.useEffect(() => {
        document.title = '재고수불부';

        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '재고관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>재고수불부</strong>" +
            '</h1>';
    }, []);
    const inputRef = React.useRef(null);
    const gridRef = React.useRef();
    const [modalToggle, setModalToggle] = React.useState(false);
    const [selectedModalData, setSelectedModalData] = React.useState(null);
    const [checkInputs, setCheckInputs] = React.useState({
        itemCd: '',
        delivOrderDate: new Date(),
        itemQty: '',
        whCd: 'WH_MM_01',
        value: '',
    });
    const autoGroupColumnDef = React.useMemo(() => {
        //그룹설정
        return {
            headerName: '수불일자',
            minWidth: 330,
        };
    }, []);
    const rowGroupPanelShow = 'always';
    const groupDefaultExpanded = 1;
    const columnDefs = [
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 70,
            // rowGroup: true,
            // enableRowGroup: true,
            hide: true,
        },
        //수불일자
        {
            field: 'tranDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PayDt' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 70,
            rowGroup: true,
            enableRowGroup: true,
            hide: true,
        },
        //거래처명
        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
            enableRowGroup: true,
        },
        //적요
        {
            field: 'remark',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Remark' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
        },
        //수불타입
        {
            field: 'transTypeNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PayType' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
            cellRenderer: Commons.CustomTransTypeRenderer,
            cellStyle: { textAlign: 'center' },
        },
        //입고수량
        {
            field: 'inQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_InQty' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 300,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
        },
        //출고수량
        {
            field: 'outQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_OutQty' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
        },
        //재고수량
        {
            field: 'stockQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_StockQty' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
            suppressMovable: true,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
        },
    ];
    const columnDefs1 = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 80,
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 70,
        },
        //품목코드
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
        },
    ];
    return (
        <div>
            <Section />
            <Card
                wrapStyle={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <DatePicker
                        className={'datepicker-custom-input'}
                        style={{ width: '120px', marginRight: '5px' }}
                        selected={props.startDate}
                        onChange={(e) => {
                            props.setStartDate(e);
                        }}
                    />
                    ~
                    <DatePicker
                        className={'datepicker-custom-input'}
                        style={{ width: '120px', marginLeft: '5px' }}
                        selected={props.endDate}
                        onChange={(e) => {
                            props.setEndDate(e);
                        }}
                    />
                    {/* <BasicInput
            containerStyle={{ flexWrap: "noWrap", width: "300px" }}
            name="거래처코드/명"
            value={props.inputs.cust}
            onChange={(e) => {
              props.setInputs({
                ...props.inputs,
                cust: e.target.value,
              });
            }}
          /> */}
                    <BasicCombo
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Fom_WhNm' && f.lanType === 'FORM')[0].lanName
                                : ''
                        }
                        value={props.inputs.whCd}
                        combos={props.whType}
                        onChange={(e) => {
                            props.setInputs({
                                ...props.inputs,
                                whCd: e,
                            });
                        }}
                    />
                    <BasicInput
                        containerStyle={{ flexWrap: 'noWrap', width: '300px' }}
                        name="품목코드/명"
                        value={props.inputs.itemListNm}
                        onChange={(e) => {
                            props.setInputs({
                                ...props.inputs,
                                itemNm: e.target.value,
                            });
                        }}
                        disabled={true}
                        onKeyDown={(e) => {
                            if (e.key == 'Enter') {
                                props.Init();
                            }
                        }}
                    />
                    {/* 품목선택 */}
                    <BasicButton
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_ItemSetting' && f.lanType === 'BTN')[0]
                                      .lanName
                                : ''
                        }
                        onClick={(e) => {
                            setModalToggle(true);
                        }}
                    />
                    {/* <Autocomplete
            freeSolo
            key={props.inputs.custList.id}
            id={props.inputs.custList.id}
            disableClearable
            sx={{ width: "200px" }}
            options={props.inputs.custList}
            getOptionLabel={(option) => option.label || ""}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label={"item"}
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                />
              );
            }}
            onChange={(e) => {
              props.inputs.custList.map((item, index) => {
                if (
                  e.target.childNodes[0]
                    ? e.target.childNodes[0].nodeValue === item.label
                    : e.target.value === item.label
                ) {
                  setCheckInputs({
                    ...checkInputs,
                    itemCd: item.id,
                  });
                }
              });
            }}
            value={props.inputs.comboList}
            // onKeyUp={(e) => {
            //   if (e.key === "Enter") {
            //     return props.GetOrders(checkInputs.itemCd);
            //   }
            // }}

            // multipleValue={_item.selectedValues}
          /> */}
                    <BasicInput
                        containerStyle={{ flexWrap: 'noWrap', width: '300px' }}
                        name="전일재고"
                        value={props.inputs.stockQty}
                        onChange={(e) => {
                            props.setInputs({
                                ...props.inputs,
                                stockQty: e.target.value,
                            });
                        }}
                        disabled={true}
                    />
                </div>
                <AuthGroupButton
                    pageName="MM10080"
                    target="G01"
                    refreshNone="none"
                    selectFunc={() => {
                        props.Init();
                    }}
                />
            </Card>
            <Section />
            <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                <AgGridReact
                    ref={gridRef}
                    animateRows={true}
                    columnDefs={columnDefs}
                    // groupDefaultExpanded={groupDefaultExpanded}
                    // rowGroupPanelShow={rowGroupPanelShow}
                    // groupIncludeTotalFooter={true}
                    autoGroupColumnDef={autoGroupColumnDef}
                    // suppressAggFuncInHeader={true} //헤더컬럼에 sum제거
                    // autoSizeAll={autoSizeAll()}
                    defaultColDef={{
                        flex: 1,
                        editable: false,
                        resizable: true,
                        sortable: true,
                        filter: true,
                        floatingFilter: true,
                    }}
                    cellDataType={false}
                    onCellValueChanged={(e) => GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)}
                    rowData={props.rowData}
                    rowSelection="single"
                    onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                    getRowStyle={(e) => (e.data ? GridFunctions.getRowStyle(e) : '')}
                />
            </div>
            {/* 거래처 팝업 */}
            {modalToggle && (
                <GridModal
                    conditions={[
                        {
                            type: 'input',
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Dia_ItemCd/Nm' && f.lanType === 'DIALOG'
                                      )[0].lanName
                                    : '', //아이템 코드/명
                            value: checkInputs.value,
                            onChange: (e) => {
                                setCheckInputs({
                                    ...checkInputs,
                                    value: e.target.value,
                                });
                            },
                            onClick: (e) => {},
                            onKeyDown: (e) => {
                                props.GetCommonItemList(checkInputs.value);
                            },
                        },
                        {
                            type: 'button',
                            style: {
                                width: '100px',
                            },
                            name:
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Btn_Search' && f.lanType === 'BTN')[0]
                                          .lanName
                                    : '', //조회
                            onClick: (e) => {
                                props.GetCommonItemList(checkInputs.value);
                            },
                        },
                    ]}
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter(
                                  (f) => f.lanId === 'Dia_ItemCodeSetting' && f.lanType === 'DIALOG'
                              )[0].lanName
                            : ''
                    }
                    onClose={() => setModalToggle(false)}
                    gridColumn={columnDefs1}
                    rowSelection="multiple"
                    gridRowData={props.authGroupGridRowData1}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_Save' && f.lanType === 'BTN')[0].lanName
                            : ''
                    }
                    gridOnClick={(e) => {
                        let data = [];
                        for (let i = 0; i < e.length; i++) {
                            data.push({
                                itemCd: e[i].itemCd,
                                itemNm: e[i].itemNm,
                            });
                        }
                        setSelectedModalData(data);
                    }}
                    gridOnDoubleClick={(e) => false}
                    execLogic={() => {
                        if (selectedModalData) {
                            for (let i = 0; i < selectedModalData.length; i++) {
                                props.inputs.itemList.push(selectedModalData[i].itemCd);
                                props.inputs.itemListNm.push(selectedModalData[i].itemNm);
                            }
                            props.setInputs({
                                ...props.inputs,
                                itemCd: selectedModalData[0].itemCd,
                                item: selectedModalData[0].itemCd,
                                itemNm: selectedModalData[0].itemNm,
                            });
                        }
                    }}
                />
            )}
        </div>
    );
}

export default ST10060;
